import { EventEmitter } from '@angular/core';

export interface UploadDialogModel {
	title: string;
	message?: string;
	onError?: EventEmitter<{ title: string; message: string }>;
	onSave?: EventEmitter<string>;
	onCancel?: EventEmitter<null>;
	onAction?: EventEmitter<string>;
	onUploadSuccess?: EventEmitter<string>;
	file?: File;
}

export enum UploadDialogTestIds {
	FileInfo = 'upload-dialog-file-info',
	Dialog = 'upload-dialog-container',
	ErrorDialog = 'upload-error-dialog-container',
	ErrorMessage = 'upload-dialog-error-message',
	SuccessMessage = 'upload-dialog-success-message',
	CloseBtn = 'upload-dialog-close-btn',
}
